import { render, staticRenderFns } from "./WorkflowJoy.vue?vue&type=template&id=2a414f3e"
import script from "./WorkflowJoy.vue?vue&type=script&lang=js"
export * from "./WorkflowJoy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports